import { call, put, takeEvery } from "redux-saga/effects";

import {
  RATE_LIST,
  RATE_CREATE,
  RATE_UPDATE,
  RATE_FILTER,
  RATE_DELETE,
} from "store/rates/actionTypes";

import {
  rateListSuccess,
  rateCreateSuccess,
  rateUpdateSuccess,
  rateDeleteSuccess,
  rateRequestFailed,
} from "store/rates/actions";

import {
  getRateList,
  postRateCreate,
  putRateUpdate,
  getRateFilter,
  deleteRate,
} from "connection/backend";

function* rateListSaga() {
  console.log("Trayendo lista de tarifas...");
  try {
    const response = yield call(getRateList);
    if (response.status === 200) {
      yield put(rateListSuccess(response.data));
    } else {
      yield put(rateRequestFailed(response.data));
    }
  } catch (error) {
    yield put(rateRequestFailed(error.response.data));
  }
}

function* rateCreateSaga({ payload: rate }) {
  console.log("Creando nueva tarifa...");
  try {
    const response = yield call(postRateCreate, rate);
    if (response.status === 201) {
      yield put(rateCreateSuccess(response.data));
    } else {
      yield put(rateRequestFailed(response.data));
    }
  } catch (error) {
    yield put(rateRequestFailed(error.response.data));
  }
}

function* rateUpdateSaga({ payload: { id, data } }) {
  console.log("Actualizando tarifa...");
  try {
    const response = yield call(putRateUpdate, { id }, data);
    if (response.status === 200) {
      yield put(rateUpdateSuccess(response.data));
    } else {
      yield put(rateRequestFailed(response.data));
    }
  } catch (error) {
    yield put(rateRequestFailed(error.response.data));
  }
}

function* rateDeleteSaga({ payload: id }) {
  console.log("Eliminando tarifa...");
  try {
    const response = yield call(deleteRate, id);
    if (response.status === 204) {
      yield put(rateDeleteSuccess());
    } else {
      yield put(rateRequestFailed(response.data));
    }
  } catch (error) {
    yield put(rateRequestFailed(error.response.data));
  }
}


function* rateFilterSaga({ payload: { changeUrl } }) {
  try {
    const response = yield call(getRateFilter, { changeUrl });
    if (response.status === 200) {
      yield put(rateListSuccess(response.data));
    } else {
      yield put(rateRequestFailed(response.data));
    }
  } catch (error) {
    yield put(rateRequestFailed(error.response.data));
  }
}

export default function* rateSaga() {
  yield takeEvery(RATE_LIST, rateListSaga);
  yield takeEvery(RATE_CREATE, rateCreateSaga);
  yield takeEvery(RATE_UPDATE, rateUpdateSaga);
  yield takeEvery(RATE_FILTER, rateFilterSaga);
  yield takeEvery(RATE_DELETE, rateDeleteSaga);
}
